export default {
  landscape: 'Na šírku',
  portrait: 'Na výšku',
};
